<script>
import Utils from "@/services/utils";
import { getReactiveNavbarLinks, areFlagsLoaded } from "@/services/navbar";
import { getReactiveBottomNavbarLinks } from "@/services/navbarBottom";
import UiNavbarMenu from "@/components/ui/NavbarMenu";
import UiNavbarHub from "@/components/ui/NavbarHub";
import UiBrandLogoWide from "@/components/ui/BrandLogoWide";
import { Icon } from "@iconify/vue2";

export default {
  name: "UiNavbar",
  components: { UiNavbarMenu, UiNavbarHub, UiBrandLogoWide, Icon },
  props: {
    acl: {
      type: [Object, Array],
      default: function () {
        return window.V.acl;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    loginUrl() {
      return Utils.getDevantBaseUrl() + "/login";
    },
    navbarLinks() {
      // This computed property will automatically react to changes in flagService.state
      // When flags are loaded, this will re-evaluate and include conditional items
      return getReactiveNavbarLinks();
    },
    navbarBottomLinks() {
      return getReactiveBottomNavbarLinks();
    },
    // Helper computed to track if flags are loaded (for debugging)
    flagsLoaded() {
      return areFlagsLoaded();
    },
  },
};
</script>

<template>
  <section
    class="navbar-2 d-flex flex-column top-0 left-0 position-fixed bottom-0 bg-white shadow-md z-1 leading-tight"
    style="width: var(--navbar-width, 256px)"
  >
    <header
      class="d-flex items-center justify-between tw-p-2 border-bottom border-gray-200"
    >
      <a :href="loginUrl" class="tw-px-2 max-w-[8rem] mr-auto">
        <UiBrandLogoWide class="mr-auto" :height="49" />
      </a>

      <b-button
        id="popover-hub"
        variant="link"
        :aria-label="$t('navigation.app_switcher')"
        class="tw-p-2 size-9 text-gray-700"
        style="border: none; line-height: 1rem"
      >
        <Icon
          icon="material-symbols:apps-sharp"
          class="size-5 d-inline-block"
        />
      </b-button>

      <b-popover
        target="popover-hub"
        triggers="click"
        placement="bottom"
        class="rounded-xl shadow-lg"
        custom-class="w-[293px] max-w-[293px] tw-px-1 tw-py-2 rounded-xl shadow-lg border-gray-200"
      >
        <template #title></template>
        <UiNavbarHub ref="focusedOnShown" />
      </b-popover>
    </header>

    <nav
      v-if="navbarLinks && navbarLinks.length"
      class="flex-1 tw-p-2 overflow-auto"
    >
      <UiNavbarMenu :links="navbarLinks" />
    </nav>
    <nav
      v-if="navbarBottomLinks && navbarBottomLinks.length"
      class="border-top border-gray-200 tw-p-2"
    >
      <UiNavbarMenu :links="navbarBottomLinks" />
    </nav>
  </section>
</template>

<style lang="scss"></style>
